<template>
    <div>
        <h3 class="mb-5 custom-title">
            SELECT ACCOMMODATION
        </h3>
        <v-card elevation="0" class="custom-title">
            <v-card-actions class="mt-5">
                <v-row>
                    <v-col cols="3">
                    </v-col>
                    <v-col cols="6" style="text-align:center;">
                        <v-btn class="add-btn" color="#3988AA" dark @click="openAddDialog()">
                            <v-icon left>mdi-plus</v-icon>
                            Add Accommodation
                        </v-btn>
                    </v-col>
                    <v-col cols="3" style="text-align:right;">
                        <v-btn @click="save()" style="background-color:green;color:white;font-weight:800;">
                            NEXT
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
        <v-card v-for="(accommodation, index) in accommodations" :key="index" outlined class="card-format mt-5">
            <v-card-text>
                <v-row dense>
                    <v-col cols="10">
                        <div class="mb-3 sublabel">CHECK IN / CHECK OUT DATES</div>
                        <v-menu v-model="accommodation.menu" :close-on-content-click="false" min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field :value="formatDateRange(accommodation)" readonly filled outlined dense
                                    placeholder="Select check in / check out dates" v-bind="attrs" v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker :value="selectedDates(accommodation)"
                                @input="onDateRangeInput(index, $event)" range no-title :min="minDate"
                                :picker-date.sync="accommodation.picker_date"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="2" style="align-content:center;">
                        <div v-if="accommodation.start_date && accommodation.end_date" dense class="sublabel" style="font-size:14px!important;color:black!important;text-align:center;">{{ $date(accommodation.end_date).diff($date(accommodation.start_date), 'day') }} night<span v-if="$date(accommodation.end_date).diff($date(accommodation.start_date), 'day') !== 1">s</span></div>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <div class="mb-3 sublabel">SELECT SUPPLIER</div>
                        <v-autocomplete v-model="accommodation.supplier" :items="getSuppliersAccommodation(accommodation)"
                            @change="onSupplierChange(index)" item-text="supplier_name" item-value="id" return-object
                            filled outlined dense
                            :disabled="accommodation.start_date == null || accommodation.end_date == null">
                            <template v-slot:selection="{ item }">
                                <b>{{ item.supplier_name }}</b>
                            </template>
                            <template v-slot:item="{ item }">
                                <b>{{ item.supplier_name }}</b>
                            </template>
                        </v-autocomplete>
                        <div v-if="unavailableNote(accommodation)" class="unavailable-note">
                            <v-icon x-small color="#C62828" class="mr-1">mdi-calendar-remove</v-icon>{{ unavailableNote(accommodation) }}
                        </div>
                    </v-col>
                </v-row>
                <v-row dense v-if="accommodation.supplier && (accommodation.supplier.products || []).length > 1">
                    <v-col cols="12">
                        <div class="mb-3 sublabel">SELECT RATE</div>
                        <v-autocomplete :value="accommodation.options[0]" :items="accommodation.supplier.products"
                            @change="onProductChange(index, $event)" item-text="name" item-value="id" return-object
                            filled outlined dense>
                            <template v-slot:item="{ item }">
                                <span>{{ item.name }}</span>
                                <v-spacer></v-spacer>
                                <span class="grey--text ml-4">{{ get_selected_company.currency }}{{ item.customer_price }}</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row dense v-if="accommodation.supplier">
                    <v-col cols="4">
                        <v-img
                            :src="api_url + 'media/suppliers/images/' + (accommodation.supplier.image || accommodation.options[0]?.image || accommodation.supplier.products?.[0]?.image)"></v-img>
                    </v-col>
                    <v-col cols="8">
                        <div v-if="accommodation.supplier.description" v-html="accommodation.supplier.description"
                            class="description">
                        </div>
                        <div v-else-if="(accommodation.options[0] || accommodation.supplier.products?.[0])?.description"
                            v-html="(accommodation.options[0] || accommodation.supplier.products[0]).description" class="description">
                        </div>
                    </v-col>
                </v-row>
                <v-row dense v-if="accommodation.supplier">
                    <v-col cols="12" v-if="accommodation.options[0] == null">
                        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
                    </v-col>
                    <v-col cols="12" v-else>
                        <div class="mb-3 sublabel">ACCOMMODATION PRICE PER NIGHT</div>
                        <div class="py-5">
                            <div class="accom-price">{{ get_selected_company.currency }}{{
                                accommodation.options[0].customer_price }}</div>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="custom-buttons mb-5">
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="confirmRemove(index)"><small>Remove</small></v-btn>
            </v-card-actions>
        </v-card>
        <v-card elevation="0" class="custom-title" v-if="accommodations.length > 0">
            <v-card-actions class="mt-5">
                <v-row>
                    <v-col cols="3">
                    </v-col>
                    <v-col cols="6" style="text-align:center;">
                        <v-btn class="add-btn" color="#3988AA" dark @click="openAddDialog()">
                            <v-icon left>mdi-plus</v-icon>
                            Add Accommodation
                        </v-btn>
                    </v-col>
                    <v-col cols="3" style="text-align:right;">
                        <v-btn @click="save()" style="background-color:green;color:white;font-weight:800;">
                            NEXT
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
        <v-dialog v-model="add_dialog" max-width="600px" persistent>
            <v-card>
                <v-card-title>Do you want to proceed in adding a new supplier?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="custom-buttons" text @click="closeAddDialog()">Cancel</v-btn>
                    <v-btn class="custom-buttons" dark @click="addAccommodation()">Add</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="remove_dialog" max-width="600px" persistent>
            <v-card>
                <v-card-title>Remove this accommodation? Any selected supplier and pricing will be lost.</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="custom-buttons" text @click="closeRemoveDialog()">Cancel</v-btn>
                    <v-btn class="custom-buttons" color="red" dark @click="removeAcommodation(remove_index)">Remove</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { unavailableForStay, unavailableLabel } from '../../../utils/supplierUnavailability'
export default {
    components: {
    },
    props: [
        'lead', 'date_range', 'suppliers', 'edit_build'
    ],
    data: () => ({
        accommodations: [],
        api_url: null,
        add_dialog: false,
        remove_dialog: false,
        remove_index: null,
    }),
    async mounted() {
        this.api_url = process.env.VUE_APP_API_URL
    },
    created() {
    },
    computed: {
        ...mapGetters({
            get_selected_company: 'auth/get_selected_company',
        }),
        minDate() {
            return this.lead?.start_date ? this.lead.start_date.split('T')[0] : null
        },
    },
    watch: {
        edit_build: {
            handler(newVal) {
                // Only run if we have new data and haven't loaded it yet
                if (newVal && newVal.length > 0 && this.accommodations.length === 0) {
                    this.$nextTick(() => {
                        this.getEditData()
                    })
                }
            },
            immediate: true
        }
    },
    methods: {
        // Hotels, minus any unavailable on one of this stay's nights (the one already picked stays, flagged).
        getSuppliersAccommodation(accommodation) {
            const current = accommodation.supplier ? accommodation.supplier.id : null
            return this.suppliers.filter((item) => {
                if (item.service_type_id !== 1) return false
                return item.id === current || !unavailableForStay(item, accommodation.start_date, accommodation.end_date)
            })
        },
        unavailableNote(accommodation) {
            const supplier = accommodation.supplier && this.suppliers.find((s) => s.id === accommodation.supplier.id)
            return unavailableLabel(unavailableForStay(supplier, accommodation.start_date, accommodation.end_date))
        },
        getEditData() {
            if (this.edit_build && this.edit_build.length > 0) {
                this.edit_build.forEach((build, index) => {
                    this.addAccommodation()
                    // Normalize date format to match date_range format (YYYY-MM-DD)
                    const normalizedStartDate = build.start_date ? build.start_date.split('T')[0] : null
                    const normalizedEndDate = build.end_date ? build.end_date.split('T')[0] : null
                    this.$set(this.accommodations[index], 'start_date', normalizedStartDate)
                    this.$set(this.accommodations[index], 'end_date', normalizedEndDate)
                    if (normalizedStartDate) {
                        this.$set(this.accommodations[index], 'picker_date', normalizedStartDate.slice(0, 7))
                    }
                    this.$set(this.accommodations[index], 'supplier', build.supplier)
                    this.$set(this.accommodations[index], 'options', build.options)
                    this.getSupplier(index)
                })
            }
        },
        openAddDialog() {
            this.add_dialog = true
        },
        closeAddDialog() {
            this.add_dialog = false
        },
        addAccommodation() {
            this.accommodations.push({
                id: null,
                start_date: null,
                end_date: null,
                supplier: null,
                options: [],
                menu: false,
                picker_date: this.minDate ? this.minDate.slice(0, 7) : null,
            })
            this.closeAddDialog()
        },
        selectedDates(accommodation) {
            return [accommodation.start_date, accommodation.end_date].filter(Boolean)
        },
        formatDateRange(accommodation) {
            if (accommodation.start_date && accommodation.end_date) {
                return `${this.$date(accommodation.start_date).format('Do MMMM YYYY')} - ${this.$date(accommodation.end_date).format('Do MMMM YYYY')}`
            }
            if (accommodation.start_date) {
                return this.$date(accommodation.start_date).format('Do MMMM YYYY')
            }
            return ''
        },
        onDateRangeInput(index, value) {
            const sorted = [...value].sort()
            this.$set(this.accommodations[index], 'start_date', sorted[0] || null)
            this.$set(this.accommodations[index], 'end_date', sorted[1] || null)
            if (sorted[0]) {
                this.$set(this.accommodations[index], 'picker_date', sorted[0].slice(0, 7))
            }
            if (sorted.length >= 2) {
                this.$set(this.accommodations[index], 'menu', false)
            }
        },
        confirmRemove(index) {
            if (this.accommodations[index].supplier) {
                this.remove_index = index
                this.remove_dialog = true
            }
            else {
                this.removeAcommodation(index)
            }
        },
        closeRemoveDialog() {
            this.remove_dialog = false
            this.remove_index = null
        },
        removeAcommodation(index) {
            this.accommodations.splice(index, 1)
            this.closeRemoveDialog()
        },
        skip() {
            this.$emit('skip')
        },
        back() {
            this.$emit('back')
        },
        triggerSave() {
            this.$emit('saveWithoutScroll', this.accommodations, 0)
        },
        save() {
            this.$emit('save', this.accommodations, 0)
        },
        // matchedRate(index) {
        //     let matched_rate = null
        //     if (this.rate[index] && this.accommodations[index].start_date && this.$date(this.accommodations[index].start_date).isBetween(this.rate[index].start_date, this.rate[index].end_date, null, '[]')) {
        //         this.rate[index].days.forEach(day => {
        //             if (this.$date(this.accommodations[index].start_date).format('dddd') == day.day)
        //                 matched_rate = day.gross
        //         })
        //     }
        //     if (matched_rate) {
        //         return parseFloat(matched_rate)
        //     }
        //     else {
        //         return 0
        //     }
        // },
        onSupplierChange(index) {
            this.accommodations[index].options = []
            this.getSupplier(index)
        },
        onProductChange(index, product) {
            this.$set(this.accommodations[index], 'options', product ? [product] : [])
        },
        // The location's supplier list (this.suppliers) already carries every supplier's
        // products, so resolve from it instead of re-fetching one supplier at a time.
        // Only falls back to the network if a build's supplier has since dropped off that
        // location's list (e.g. its location assignment changed after the quote was saved).
        async getSupplier(index) {
            const current = this.accommodations[index].supplier
            if (!current) return
            let full = this.suppliers.find((s) => s.id === current.id)
            if (!full) {
                const { data } = await this.$axios.get(`admin/suppliers/get_supplier/${current.id}`)
                if (!data.response) return
                full = data.data
            }
            this.$set(this.accommodations[index], 'supplier', full)
            this.$set(this.accommodations[index], 'options', [this.pickProduct(full, this.accommodations[index])])
        },
        // The product (rate) for this stay: the one already saved on the quote if it is still there, else
        // the best match for the check-in month and number of nights (rates named like "Jan - 2 nights - 6-11 pax"),
        // else the supplier's first product.
        pickProduct(supplier, accommodation) {
            const products = supplier.products || []
            const saved = accommodation.options && accommodation.options[0]
            const kept = saved && products.find((p) => p.id === saved.id)
            if (kept) return kept
            if (products.length > 1 && accommodation.start_date) {
                const month = this.$date(accommodation.start_date).format('MMM').toLowerCase()
                const nights = accommodation.end_date ? this.$date(accommodation.end_date).diff(accommodation.start_date, 'day') : null
                // Any " - " part of the name can be the month ("Luxmar Apartments - Jan - 2 nights - 6-11 pax"),
                // so "Janelas Do Mar" is not read as January
                const monthWord = /^(jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|june?|july?|aug(ust)?|sept?(ember)?|oct(ober)?|nov(ember)?|dec(ember)?)\b/
                const inMonth = products.filter((p) => (p.name || '').toLowerCase().split(' - ').some((part) => {
                    const m = monthWord.exec(part.trim())
                    return m && m[0].slice(0, 3) === month
                }))
                const exact = inMonth.find((p) => {
                    const m = /(\d+)\s*nights?/i.exec(p.name || '')
                    return m && parseInt(m[1]) === nights
                })
                if (exact || inMonth[0]) return exact || inMonth[0]
            }
            return products[0]
        },
    }
}
</script>

<style lang="scss" scoped>
.unavailable-note {
    font-family: Manrope;
    font-size: 12px;
    font-weight: 600;
    color: #C62828;
    margin-top: 4px;
}

.card-format {
    padding: 24px;
    border-radius: 20px !important;

    .card-footer-format {
        border-top: 1px solid #E9E9E9;
        background-color: #E9E9E9;
    }
}

.card-footer-format {
    .pagination-font-format {
        font-family: 'Work Sans';
        font-size: 14px;
    }

    .bg-color-white {
        background-color: white;
    }
}

:deep(.v-input__slot) {
    background: white !important;
}

:deep(.v-stepper__header) {
    box-shadow: none !important;
}

.accom-price {
    color: #FAAF3A;
    font-size: 36px;
    font-weight: 600;
}

.custom-title {
    font-family: 'Manrope';
    font-size: 14px !important;
    color: #3988AA;
    font-weight: 600;
}

.sublabel {
    color: #7C7C7C;
    font-family: Manrope;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.description {
    color: #7D7D7D;
    font-family: Manrope;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.summary {
    color: #7C7C7C;
    font-family: Manrope;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 20px;
}

:deep(.custom-buttons span) {
    font-family: Manrope;
    font-size: 13px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: normal;
    box-shadow: none !important;
}

:deep(.custom-buttons button) {
    padding: 8px 7px 8px 7px !important;
    border-radius: 5px;
}

.add-btn {
    font-family: Manrope;
    font-size: 14px !important;
    font-weight: 700 !important;
    text-transform: none;
    border-radius: 8px;
    padding: 0 20px !important;
}
</style>